var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('div',{staticClass:"user-info"},[_c('avatar',{attrs:{"user":_vm.user}}),_c('div',{staticClass:"user-mates"},[_c('div',{staticClass:"user-id"},[_vm._v(_vm._s(_vm.user.userId))]),_c('div',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.user.nickname))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }